import { 
    lateRuleSelectOptions,
    undertimeRuleSelectOptions,
    absentRuleSelectOptions,
    overtimeRuleSelectOptions,
    longevityRuleSelectOptions,
    holidayRuleSelectOptions,
    nightshiftRuleSelectOptions,
    restdayRuleSelectOptions
  } from "../../variables/Variables.jsx";

export const getFriendlyRuleName = (rule, value) => {
    let label;
    let filteredArray = [];

    console.log('aqui')
    console.log('rule', rule)
    console.log('value', value)

    switch(rule) {
        case 'lateRule':
            filteredArray = lateRuleSelectOptions.filter((option) => {
                return option.value === value;
            });
            label = filteredArray[0].label;
            break;
        case 'absentRule':
            filteredArray = absentRuleSelectOptions.filter((option) => {
                return option.value === value;
            });
            label = filteredArray[0].label;
            break;
        case 'overtimeRule':
            filteredArray = overtimeRuleSelectOptions.filter((option) => {
                return option.value === value;
            });
            label = filteredArray[0].label;
            break;
        case 'longevityRule':
            filteredArray = longevityRuleSelectOptions.filter((option) => {
                return option.value === value;
            });
            label = filteredArray[0].label;
            break;
        case 'holidayRule':
            filteredArray = holidayRuleSelectOptions.filter((option) => {
                return option.value === value;
            });
            label = filteredArray[0].label;
            break;
        case 'nightShiftRule':
            filteredArray = nightshiftRuleSelectOptions.filter((option) => {
                return option.value === value;
            });
            label = filteredArray[0].label;
            break;
        case 'restdayRule':
            filteredArray = restdayRuleSelectOptions.filter((option) => {
                return option.value === value;
            });
            label = filteredArray[0].label;
            break;
        case 'undertimeRule':
            filteredArray = undertimeRuleSelectOptions.filter((option) => {
                return option.value === value;
            });
            label = filteredArray[0].label;
            break;
        default:
            label = "Rule not supported by the system";
    }

    console.log('filteredArray');
    console.log(JSON.stringify(filteredArray))
    console.log('label', label)

    return label;
}
